import { useTranslation } from "react-i18next";
import MmcGraph from "../pages/graph";
import Legend from "./Legend";
import {useContext} from "react";
import InitContext from "../pages/InitContext";
import {Consts} from "../pages/consts";
import {buildInteractionParam} from "../pages/utils";
import DdiElement from "./DdiElement";
import {buildDdiProduct} from "./utils";

const DrugsGraph = ({
  selectedDrug,
  nodes,
  edges,
  handleSelected,
}) => {
  const { t: t } = useTranslation();

  const ddiLegendItemsHcp = [
    { color: "", label: t("legends_ddi_drugs")},
    { color: "#4CAF50", label: t("legends_no_ddis_expected") },
    { color: "#FFC107", label:  t("legends_minor_ddis") },
    { color: "#c9410c", label: t("legends_moderate_ddis") },
    { color: "#f10909", label: t("legends_severe_ddis_and_cis") },
    { color: "#627079", label: t("legends_no_statement_possible") },
  ];

  const ddiLegendItemsPatient = [
    { color: "", label: t("legends_ddi_drugs") + ": " },
    { color: "#1b7a9f", label: t("legends_ddis_detected") },
  ];

  const dgiLegendItems = [
    { color: "", label: t("legends_dgi_bg_colors") + ": " },
    { color: "#1b7a9f", label: t("legends_ddis_available") }
  ];

  const context = useContext(InitContext);

  const sortedDdis = selectedDrug?.ddis?.sort((a, b) => {
    if (a.ddiDrug?.activeSubstance < b.ddiDrug?.activeSubstance) return -1;
    if (a.ddiDrug?.activeSubstance > b.ddiDrug?.activeSubstance) return 1;
    return 0;
  });

  return (
    <div className="w3-container form-content-scroll">
      <div className="w3-row">
        <Legend
          items={
            context?.role === Consts.PATIENT
              ? ddiLegendItemsPatient
              : ddiLegendItemsHcp
          }
        />
      </div>
      <div className="w3-row">
        <Legend items={dgiLegendItems} />
      </div>
      <div className="w3-row">
        {!selectedDrug?.id && (
          <p className="w3-center w3-margin-top w3-white">
            <label>
              {t("please_select_a_drug_from_the_graph_to_see_more_details")}
            </label>
          </p>
        )}
      </div>
      <div className="w3-row">
        <div className="w3-third w3-left-align w3-padding-small">
          {selectedDrug?.id && (
            <>
              <div className="w3-row w3-padding-small">
                <div className="w3-half">
                  <label className="bold-label">
                    {selectedDrug?.productName === Consts.NOT_SPECIFIED || selectedDrug?.productName === Consts.ANY
                      ? `(${t(Consts.NOT_SPECIFIED).toLowerCase()})`
                      : selectedDrug?.productName
                    }
                  </label>
                </div>
              </div>
              <div className="w3-row w3-padding-small">
                <label>
                  {t("active_component")}: {selectedDrug?.activeSubstance?.replaceAll("&&&", ", ")}
                </label>
              </div>
              <div className="w3-row w3-padding-small">
                <label>
                  {t("prescription_date")}: {selectedDrug?.startDate}
                </label>
              </div>
              {sortedDdis?.length > 0 && (
                <div className="w3-border w3-round-large w3-margin-top w3-margin-bottom">
                  <div className="w3-row w3-padding-small">
                    <label className="bold-label">
                      {t("interactions_with_other_medicines")}:{" "}
                    </label>
                  </div>
                  <div className="w3-row w3-padding-small">
                    {sortedDdis?.map((ddi, i) => {
                      return (
                        <DdiElement
                          ddi={ddi}
                          productName={buildDdiProduct(ddi?.ddiDrug, t("not_specified"))}
                          key={`ddi${i}`}
                        />
                      );
                    })}
                  </div>
                </div>
              )}
              {selectedDrug?.dgis?.length > 0 && (
                <div className="w3-margin-bottom">
                  <div className="w3-row w3-padding-small">
                    <label className="bold-label">
                      {t("drug_gene_interactions_with")}
                    </label>
                  </div>
                  <div className="w3-row w3-padding-small interactions-info-text">
                    {selectedDrug?.dgis?.map((dgi, i) => (
                      <div key={i}>
                        <div>
                          <label className="color-teal">
                            {i + 1}:{dgi?.gene}
                          </label>
                        </div>
                        <div>
                          <label className="color-teal">
                            {t("genotype")}: {dgi?.genotype}
                          </label>
                        </div>
                        {dgi.genotypeRecommendation && (
                          <div className="accordion-body-item w3-margin-bottom">
                            <label className="w3-margin-right">
                              {t("recommendation")}:{" "}
                              { buildInteractionParam(dgi?.genotypeRecommendation, true) }
                            </label>
                          </div>
                        )}
                        <div>
                          <label className="color-teal">
                            {t("phenotype")}: {t(dgi?.phenotype)?.toLowerCase()}
                          </label>
                        </div>
                        { dgi.phenotypeRecommendation &&
                          <label className="w3-margin-right">
                            {t("recommendation")}: { buildInteractionParam(dgi?.phenotypeRecommendation, true) }
                          </label>
                        }
                        { dgi.completeRecommendation &&
                          <label className="w3-margin-right">
                            {t("recommendation")}:  { buildInteractionParam(dgi?.completpeRecommendation, true) }
                          </label>
                        }
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        <div className="w3-twothird">
          {nodes ? (
            <div className="drugs-content-scroll">
              <MmcGraph
                nodes={nodes}
                edges={edges}
                handleSelected={handleSelected}
              />
            </div>
          ) : (
            <div>
              <div className="drugs_graph_label">
                <label>{t("no_medicines_to_show")}</label>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DrugsGraph;
